<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('table.action.modify')}}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item v-if="resourceType === 'organization_nodes'" :label="$t('iamee.parent_organization')">
          {{form.parent_label}}
        </a-form-model-item>
        <a-form-model-item :label="$t('table.title.name')" prop="name">
          <a-input v-if="resourceType === 'organizations'" v-model="form.name" :placeholder="$t('common.tips.input', [$t('table.title.name')])" />
          <span v-else>{{form.name}}</span>
        </a-form-model-item>
        <a-form-model-item v-if="resourceType !== 'organizations'" :label="$t('iamee.weight')" prop="weight" :extra="$t('iamee.weight_extra')">
          <a-input-number v-model="form.weight" :min="1" :step="1" :precision="0" :placeholder="$t('common.tips.input', [$t('iamee.weight')])" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item :label="$t('table.title.desc')" prop="description">
          <a-input v-model="form.description" :placeholder="$t('common.tips.input', [$t('table.title.desc')])" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'OrganizationNodeEditDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { orgId, nodeId, nodeList } = this.params
    const targets = nodeList.filter(item => item.key === nodeId)
    const node = targets[0] || {}
    let parentLabel = '-'
    if (node.key && node.key !== 'root') {
      const full = node.parentFullLabel || node.parentLabel
      const parts = full ? String(full).split('^^').filter(Boolean) : []
      parentLabel = parts.length ? parts.join(' / ') : '-'
    }
    return {
      orgId,
      currentNode: node,
      form: {
        name: node.tagValue,
        parent_label: parentLabel,
        weight: node.weight,
        description: node.description,
      },
      rules: {
        name: { required: true, message: this.$t('common.tips.input', [this.$t('table.title.name')]) },
        weight: { required: true, message: this.$t('common.tips.input', [this.$t('iamee.weight')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      resourceType: node.key === 'root' ? 'organizations' : 'organization_nodes',
    }
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        const data = {
          weight: this.form.weight,
          description: this.form.description,
        }
        let id = this.currentNode.key
        if (this.resourceType === 'organizations') {
          data.name = this.form.name
          id = this.orgId
        }
        await new this.$Manager(this.resourceType, 'v1').update({
          id,
          data,
        })
        this.loading = false
        this.cancelDialog()
        this.params.success(this.resourceType)
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
